module.exports = __webpack_public_path__ + "media/images/short_scenario_contest/label-1st@2x-5b17fd3c8d7caab0dd6382f7497e87d7.png";